import React, { useState } from "react";
import { isFunction } from "utils";
import ReactModal from "react-modal";
import "./Modal.css";

export const useModal = () => {
  const [modalState, setModalState] = useState(false);
  const closeModal = () => setModalState(false);
  const openModal = (openCallback) => {
    setModalState(true);
    if (isFunction(openCallback)) openCallback();
  };

  const Modal = ({ children, onRequestClose = closeModal, ...props }) => {
    return (
      <ReactModal
        appElement={document.getElementsByTagName("body")[0]}
        isOpen={modalState}
        onRequestClose={onRequestClose}
        overlayClassName="three-ds-modal-overlay"
        className="three-ds-modal-content"
        {...props}
      >
        <div style={{ width: "100%", height: "100%" }}>{children}</div>
      </ReactModal>
    );
  };

  return [Modal, openModal, closeModal];
};
